import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'login-master',
  templateUrl: './not-loggedin.master.html',
  styleUrls: ['./not-loggedin.master.scss'],
  imports: [RouterOutlet],
})
export class NotLoggedInMasterComponent {}
